import { Popover } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import "./index.scss";
import moment from "moment";
import { MonthCalendar } from "./monthCalendar";
import { QuarterCalendar } from "./quarterCalendar";
import { YearCalendar } from "./yearCalendar";
import { DatePickerFilterOption } from "interfaces";

interface IOption {
  id: DatePickerFilterOption;
  label: string;
  startDate?: Date;
  endDate?: Date;
}

const DATEPICKER_OPTIONS: IOption[] = [
  {id: DatePickerFilterOption.MONTH, label: "Month"},
  {id: DatePickerFilterOption.QUARTER, label: "Quarter"},
  {id: DatePickerFilterOption.YEAR, label: "Year"}
]

interface DatePickerInputProps {
  defaultOption?: DatePickerFilterOption;
  defaultDate?: string;
  _handleDateChange: (data: any, type: any) => void;
}

const getDateText = (date: string, dateOption: DatePickerFilterOption) => {
  switch(dateOption) {
    case DatePickerFilterOption.YEAR: return date;
    case DatePickerFilterOption.QUARTER: return `Q1/${date} - Q4/${date}`;
    case DatePickerFilterOption.MONTH: return `${moment(date, "MM-YYYY").startOf('month').format('DD/MM/YYYY')} - ${moment(date, "MM-YYYY").endOf('month').format('DD/MM/YYYY')}`

  }
}
export const ChartDatePickerInput = ({defaultOption = DatePickerFilterOption.DAYS, defaultDate, _handleDateChange} :DatePickerInputProps) => {

  const [date, setDate] = useState<string | null>(defaultDate ?? null);

  const [triggerResetState, setTriggerResetState] = useState(false);

  const [selectedFilerOptionId, setSelectedFilterOptionId] = useState<DatePickerFilterOption>(defaultOption);

  const onChange = (selectedDate: any) => {
    setDate(selectedDate);
  };

  const _handleClickDatePickerOption = (option: IOption) => {
    if (selectedFilerOptionId !== option.id) {
      setSelectedFilterOptionId(option.id);
      onChange(null);  
    }
  }

  const _renderFilterDatePicker = () => {
    const calendarProps = {
      date,
      onChange: (date: any) => {
        onChange(date);
      }
    }
    switch (selectedFilerOptionId) {
      // case DatePickerFilterOption.DAYS: return <DayCalendar {...calendarProps} />;
      // case DatePickerFilterOption.WEEK: return <WeekCalendar {...calendarProps} />;
      case DatePickerFilterOption.MONTH: return <MonthCalendar {...calendarProps} />;
      case DatePickerFilterOption.QUARTER: return <QuarterCalendar {...calendarProps} />;
      case DatePickerFilterOption.YEAR: return <YearCalendar {...calendarProps} />;
      default: return;
    }
  }

  useEffect(() => {
    if (triggerResetState) {
      setDate(defaultDate ?? null);
      setSelectedFilterOptionId(defaultOption);
      setTriggerResetState(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerResetState])

  return (
    <Popover className="relative w-full" id="chart-date-picker">
      <Popover.Button 
        className="w-full text-left border border-solid border-gray-300 focus:!outline-none focus:border-gray-300 focus:ring-0 rounded-lg px-2.5 py-2"
        onClick={() => setTriggerResetState(true)}
      >
        <span className="text-sm capitalize">
          {defaultOption} ({getDateText(defaultDate ?? "", defaultOption) ?? "Date"})
        </span>
      </Popover.Button>

      <Popover.Panel className="absolute z-10 pt-2 w-full sm:w-[400px] left-0 sm:left-auto sm:right-0">
        {({ close }) => (
          <div className="flex bg-white rounded-md shadow-md border border-solid border-gray-100">
            <div className="px-4 w-32 shrink-0 box-border">
              <div className="flex flex-col gap-y-2 text-sm py-3 border-t border-gray-200">
                {DATEPICKER_OPTIONS.map(option => (
                  <button 
                    key={option.id}
                    className={`flex justify-between items-center ${selectedFilerOptionId === option.id ? "text-brand-600 font-semibold" : ""}`}
                    onClick={() => _handleClickDatePickerOption(option)}
                  >
                    {option.label}
                    <ChevronRightIcon className="w-3 h-3" />
                  </button>
                ))}
              </div>
            </div>
            <div className="mx-auto py-2 flex flex-col">
              {_renderFilterDatePicker()}
              <div className="text-sm w-full flex justify-center items-center border-t border-gray-200 pt-3.5 pb-3.5">
                <button 
                  className="bg-brand-500 text-white px-4 py-1.5 rounded-sm w-full active:opacity-85" 
                  onClick={() => {
                    if (date) {
                      _handleDateChange(date, selectedFilerOptionId)
                    }
                    close();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </Popover.Panel>
    </Popover>
  );
}